import { Component, forwardRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { PrFormListItemComponent } from '@app/components/pr-form/pr-form-list-item/pr-form-list-item.component';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { combineLatest, Subject } from 'rxjs';
import { EaRentFormService } from './ea-rent-form.service';

@Component({
    selector: 'ea-rent-form',
    templateUrl: './ea-rent-form.component.html',
    styleUrls: ['./ea-rent-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaRentFormComponent),
        },
    ],
    standalone: false
})
export class EaRentFormComponent extends PrFormAbstract implements OnInit {
  /* connaissances = [
    { id: 'netMensuel', label: 'Net mensuel', suffix: '€/mois' },
    { id: 'netAnnuel', label: 'Net annuel', suffix: '€/an' },
    { id: 'brutMensuel', label: 'Brut mensuel', suffix: '€/mois' },
    { id: 'brutAnnuel', label: 'Brut annuel', suffix: '€/an' }
  ]; */

  @ViewChild(PrFormListItemComponent) formListITem: PrFormListItemComponent;

  estateTypes = [];
  periodicityTypes = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    public EaRentFormService: EaRentFormService,
    protected refDao: ReferenceDao,
  ) {
    super(formConstructor);
    this.EaRentFormService.generateSubject.subscribe(
      formGroup => (this.form = formGroup),
    );
  }

  ngOnInit() {
    if (!this.form.controls) this.initForm(this.entity);
    combineLatest([
      this.refDao.getEstateType(),
      this.refDao.getPeriodicityType(),
    ]).subscribe(([estateTypes, periodicityTypes]) => {
      this.estateTypes = estateTypes;
      this.periodicityTypes = periodicityTypes;
    });
  }

  onDelete(index) {
    this.EaRentFormService.removeModel(
      index,
      this.rents,
      this.entity.userId,
      this.entity.typeUrl,
      this.entity.id,
    );
    this.entity.rents.splice(index, 1);
  }

  get rents(): UntypedFormArray {
    return this.form.get('rents') as UntypedFormArray;
  }

  validate(fee) {
    // this.formListITem.close()
    // this.form
  }

  public generate(): any {
    return this.EaRentFormService.generate(this.entity);
  }

  public extract() {
    return this.EaRentFormService.extract(this.form);
  }

  onSubmit() {}

  doneSubject = new Subject<void>();
}
